import { createDeviceInfoFromCookies } from "@sitebase/device-detector";
import {
  IframeConfig,
  WidgetConfig,
  WidgetType,
  WIDGET_METADATA,
  WIDGET_TYPES,
} from "./config";
import { MessageBusType } from "../services/messageBus";

const getOrigin = (url: string): string => new URL(url).origin;

export const getIframeOrigin = (widgetType: WidgetType): string =>
  getOrigin(getIframeUrl(widgetType) || "");

export const classByDevice = (): string => {
  const deviceInfo = createDeviceInfoFromCookies(
    window.document.cookie,
    // eslint-disable-next-line no-console
    (e: unknown) => console.log("DeviceInfo: ", e),
  );

  if (deviceInfo.isDesktop) return "isDesktop";
  if (deviceInfo.isTablet) return "isTablet";
  return "isMobile";
};

export const getLocale = (): string =>
  window.WH?.sportsbook?.lang || WidgetConfig.LOCALE_DEFAULT;

const getBaseUrl = (widgetType: WidgetType) => {
  const isTest = window.localStorage.getItem("PBB_TEST") === "true";
  if (isTest) return IframeConfig[widgetType].URLS.TEST;
  return getLocale() === WidgetConfig.LOCALE_ES
    ? IframeConfig[widgetType].URLS[WidgetConfig.LOCALE_ES]
    : IframeConfig[widgetType].URLS[WidgetConfig.LOCALE_DEFAULT];
};

export const getIframeUrl = (widgetType: WidgetType): string => {
  const baseUrl = getBaseUrl(widgetType);
  const split = window.location?.href?.split("/");
  const eventId = split.find((item) => item.includes("OB_EV"));

  if (!eventId) return baseUrl;

  const metadata = WIDGET_METADATA[widgetType];
  const url = new URL(baseUrl);
  url.searchParams.set(metadata.eventIdParam, eventId);
  
  return url.toString();
};

// messageBus getter
export const getMessageBus = (): MessageBusType => {
  if (
    !window.WH?.messageBus?.publish ||
    !window.WH?.messageBus?.subscribe ||
    !window.WH?.messageBus?.unsubscribe
  ) {
    throw Error("MessageBus not found");
  }
  return window.WH.messageBus;
};
const getEventId = (): string | undefined => window.WH?.sportsbook?.eventId;

export const isEventPage = (): boolean => !!getEventId();

export const getPopularBetBuilderEventCategory = (): string => {
  return `${isEventPage() ? "Event" : "Global"} Popular Bet Builder Interactions`;
};

export const getPopularBetBuilderBetListName = (): string => {
  return isEventPage()
    ? "POPULAR-BETBUILDERS-EVENT"
    : "POPULAR-BETBUILDERS-GLOBAL";
};

export const getAccaBetListName = (widgetType: WidgetType): string => {
  return widgetType === WIDGET_TYPES.ACCA_HORSE_RACING
    ? "POPULAR-ACCAS-HORSE-RACING"
    : "POPULAR-ACCAS-FOOTBALL";
};

export const getAccaTrackingEvent = (
  widgetType: WidgetType,
  action: "add" | "remove",
): string => {
  const sport = widgetType === WIDGET_TYPES.ACCA_HORSE_RACING ? "racing" : "football";
  return `${sport}_ACCAS_HUB_betslip_${action}`;
};
